import { DirectiveOptions } from 'vue';
import { SegmentWrapper } from './segment';

export const TrackClick: DirectiveOptions = {
  bind(el, binding) {
    el.addEventListener('click', () => {
      SegmentWrapper.elementClicked(binding.value);
    });
  },
};
